export const getItemFromLocalStorage = (key) => {
    return localStorage.getItem(key);
  };
  